import React from "react";
import ActorKnownCard from "./ActorKnownCard";
import ActorUnknownCard from "./ActorUnknownCard";


const ActorCard = ({actorUid}) => actorUid ? <ActorKnownCard actorUid={actorUid} /> : <ActorUnknownCard />

export default ActorCard;
